import { Navigate } from 'react-router-dom';

/**
 * Placeholder para páginas futuras de produto (/converlead, /axys).
 */
const ProductPlaceholderPage = ({ product }) => (
  <Navigate to="/" state={{ scrollTo: product }} replace />
);

export default ProductPlaceholderPage;
